export enum PcsStatusEnum {
    Approved = "AA",
    AwaitingPayment = "AP",
    Declined = "DD",
    Incomplete = "IC",
    Pending = "PE",
    Withdrawn = "WN"
}